import { LoginComponent } from './../01.2-page/login/login.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from '../01.2-page/pageNotFound/pageNotFound.component';

const routes: Routes = [
  {
    path: '',
    loadChildren:  () => import('./../01.2-page/home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'login', component: LoginComponent
  },
  {
    path: '', redirectTo: '/resume' , pathMatch: 'full'
  },
  {
    path: '**', component: PageNotFoundComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
